module.exports = __webpack_public_path__ + "img/smu.6382521d.jpg";